import {createNavigationContainerRef} from '@react-navigation/native';
import type {NavigationRef} from './types';

const navigationRef: NavigationRef = createNavigationContainerRef();

export default navigationRef;
